<template lang='pug'>
  #catalogs.view( v-if='account.merchant' )
    base-modal#new-service.form(
      :show='show.new'
    )
      component(
        :is='`set-${type}`'
        :categories='categories'
        :account='account'
        :biz='biz'
        @set='show.new = false'
        @close='show.new = false'
        @categorize='show.new = false; $emit("categorize")'
      )
        template( v-slot:header ) {{ $t(`New ${type.charAt(0).toUpperCase() + type.slice(1)}`) }}

    base-modal#edit-service.form(
      :show='!!show.edit'
      @close='show.edit = false'
    )
      component(
        :is='`set-${type}`'
        :categories='categories'
        :account='account'
        :settable='editable'
        :biz='biz'
        @set='show.edit = false'
        @close='show.edit = false'
        @categorize='show.edit = false; console.log( "catalogs emiting..." ); $emit("categorize")'
      )
        template( v-slot:header ) {{ $t(`Edit ${type.charAt(0).toUpperCase() + type.slice(1)}`) }}
        template( v-slot:footer) {{ $t('Update') }}

    .items( v-if='account.merchant == "value"' )
      bf-flex.centered.add-button.actionable(
        @click.native='make'
      )
        bf-flex.centered.icon
          new-icon
        span {{ $t("ADD")}}

      bf-flex.item.actionable( 
        v-for='item in filtered' 
        @click.native='edit( item )' 
        :key='item.id' 
      )
        .delete( @click.stop='remove( item )' )
          delete-icon
        featured-image.image( :collection='collection' :doc='item' )
        .text
          h5.title {{ item.title }}
          p.desc {{ item.description }}
    
    bf-flex.centered.upgradable( v-else )
      article
        h5 {{$t('Please subscribe for the "Value Merchant" to use this function')}}
        h5 {{$t("This function allows you to upload your products' Menu/Catalog")}}
        bf-divider.section.borderless
        .buttons.centered-text
          bf-button( @click.native='$router.push({ name: "account", params: { preset: "value" } })' )
            template( v-slot:text ) {{$t("Upgrade to Value Merchant")}}
</template>

<script>
  import { View } from '@/mixins/view'
  import { Sellable } from '@/mixins/sellable'
  import SetCatalog from '@/components/set-catalog'

  export default {
    name: 'catalogs.view',
    
    mixins: [ View, Sellable ],

    components: {
      SetCatalog
    },

    data() {
      return {
        type: 'catalog',
        collection: 'catalogs',
      }
    }
  }

</script>

<style scoped lang='stylus'>
  .add-button
    width 100px
    font-weight bold
    font-size 1.2em
    background white
    padding 10px
    border 1px solid rgb(200 200 200)
    border-radius 5px
  .upgradable
    article
      background white
      line-height 2
      width 320px
      border 3px solid red
      border-radius 3px
      padding 32px
  .items
    .item
      background white
      border-radius 8px
      border 1px solid rgb( 240 240 240 )
      position relative
      box-shadow var(--shadow-card)
      overflow hidden
      margin 16px 0
      width 100%
      flex-flow row
      &:hover
        box-shadow var(--shadow-card-hover)
      .delete
        position absolute
        right 8px
        top 8px
        font-size 1.2em
      .image
        flex-grow 0
        flex-basis 0
        img
          display block
          width 100%
          height 100%
          object-fit cover
      .text
        padding 12px
        flex-grow 5
        flex-basis 0
        p
          font-size 1.2em
        .title
          padding-right 24px
</style>
